export default "__VITE_ASSET__e8a44ce3__"